import PropTypes from 'prop-types';

import './video-block.scss';

const VideoBlock = ({ label, id }) => {
  const src = `https://www.youtube.com/embed/${id}`;

  return (
    <section className="video-block">
      <section className="video-block__text">
        <p>{label}</p>
      </section>
      <section className="video-block__box">
        <div className="video-block__video">
          <iframe
            src={src}
            className="video-block__video"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullScreen="allowfullscreen"
          />
        </div>
      </section>
    </section>
  );
};

VideoBlock.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default VideoBlock;
